import { useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { FiActivity, FiBookOpen, FiInbox, FiList, FiMail, FiShield, FiUploadCloud, FiUsers } from 'react-icons/fi';
import { AdminViewLayout } from '../../_Shared/_UI/AdminViewLayout';
import { EmailModuleGuide } from './EmailModuleGuide';
import './_Styles/EmailAdmin.css';

const tabs = [
    { to: '/dashboard/correos', label: 'Resumen', icon: <FiActivity />, end: true },
    { to: '/dashboard/correos/contactos', label: 'Contactos', icon: <FiUsers /> },
    { to: '/dashboard/correos/listas', label: 'Listas', icon: <FiList /> },
    { to: '/dashboard/correos/importar', label: 'Importar', icon: <FiUploadCloud /> },
    { to: '/dashboard/correos/plantillas', label: 'Plantillas', icon: <FiBookOpen /> },
    { to: '/dashboard/correos/campanas', label: 'Campañas', icon: <FiMail /> },
    { to: '/dashboard/correos/cola', label: 'Cola e historial', icon: <FiInbox /> },
    { to: '/dashboard/correos/bloqueos', label: 'Bloqueos', icon: <FiShield /> },
];

export const EmailSectionLayout = ({ title, description, children, actions = null }) => {
    const { pathname } = useLocation();

    /*
        Cada subvista del modulo arranca desde su cabecera, igual que el resto
        del administrador. React Router conserva por defecto el scroll anterior;
        en una navegacion por tabs eso dejaba la vista empezando a mitad de pagina.
    */
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }, [pathname]);

    return (
        <AdminViewLayout
            pageKey="email"
            eyebrow="Portfolio Mail"
            title={title}
            description={description}
            actions={actions}
            isWide
        >
            <nav className="PBMAIL__tabs" aria-label="Modulo de correos">
                {tabs.map((tab) => (
                    <NavLink key={tab.to} to={tab.to} end={tab.end} title={tab.label} className={({ isActive }) => `PBMAIL__tab${isActive ? ' is-active' : ''}`}>
                        {tab.icon}<span>{tab.label}</span>
                    </NavLink>
                ))}
            </nav>
            <EmailModuleGuide />
            {children}
        </AdminViewLayout>
    );
};
